export default __webpack_public_path__ + "d3c6e916f9fb6539edb3f2228bbbfb40.svg";